import { PERSON_TYPE, PERSON_TYPE_IDENTIFIER } from '../constants/stringConstants';

export default class Person {
  address?: string;
  email: string;
  firstName?: string;
  hasSigned?: boolean;
  lastName?: string;
  fullName?: string;
  isItMe?: boolean;
  leaseId?: string;
  ouid?: string;
  userIdentifier?: string;
  userType?: string;

  constructor(args) {
    this.address = args.address;
    this.email = args.email;
    this.firstName = args.firstName;
    this.hasSigned = args.hasSigned;
    this.lastName = args.lastName;
    this.leaseId = args.leaseId != null ? String(args.leaseId) : undefined;
    this.userIdentifier = args.userIdentifier;
    this.isItMe = args.isItMe;
    this.fullName = args.fullName || this.getFullName();
    this.ouid = args.ouid;
    this.userType = args.userType;
  }

  getFullName(): string | null {
    const nameParts = [];

    if (this.firstName) {
      nameParts.push(this.firstName);
    }

    if (this.lastName) {
      nameParts.push(this.lastName);
    }

    return nameParts.length > 0 ? nameParts.join(' ') : null;
  }

  static getOUIDfromSearch(search: string = window.location.search): string | null {
    const urlParams = new URLSearchParams(search);

    return urlParams.get('ouid');
  }

  static isColandlord(person: Person): boolean {
    return (
      person && person.userType === PERSON_TYPE.LANDLORD && person.userIdentifier === PERSON_TYPE_IDENTIFIER.COLANDLORD
    );
  }
}
